const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const STORE = "gdih_utm";

export function captureUtm() {
  try {
    const p = new URLSearchParams(window.location.search);
    const cur = getUtm();
    let found = false;
    KEYS.forEach((k) => { const v = p.get(k); if (v) { cur[k] = v; found = true; } });
    if (found) localStorage.setItem(STORE, JSON.stringify(cur));
  } catch (e) { /* no-op */ }
}

export function getUtm() {
  try { return JSON.parse(localStorage.getItem(STORE) || "{}"); }
  catch (e) { return {}; }
}
